class SelfInviteService {
  constructor(Authentication, SlingApi) {
    'ngInject';

    Object.assign(this, { Authentication, SlingApi });
  }

  _slugPromise = null;

  getInviteSlug() {
    if (!this._slugPromise) {
      const orgId = this.Authentication.user.org.id;
      this._slugPromise = this.SlingApi.getInviteSlug(orgId);
    }

    return this._slugPromise;
  }
}

export default SelfInviteService;
